import { ActivatedRoute, Router } from '@angular/router';
import { OrderManager } from 'aigens-ng-core';
import { NavController } from '@ionic/angular';
import { NavigationService } from '../services/navigation.service';
import * as i0 from "@angular/core";
import * as i1 from "aigens-ng-core/dist/manager/order-manager";
import * as i2 from "@angular/router";
import * as i3 from "@ionic/angular";
import * as i4 from "../services/navigation.service";
var CrmFeatureGuard = /** @class */ (function () {
    function CrmFeatureGuard(orderManger, router, route, navController, navigationService) {
        this.orderManger = orderManger;
        this.router = router;
        this.route = route;
        this.navController = navController;
        this.navigationService = navigationService;
    }
    CrmFeatureGuard.prototype.canLoad = function (route, segments) {
        console.log('can crm load', this.orderManger);
        if (this.orderManger.store && this.orderManger.store.brand && this.orderManger.store.brand.hasFeature('login')) {
            return true;
        }
        else {
            var t = this.navigationService.getRootPageUrl();
            console.log('home guard', t);
            if (t) {
                // TODO: not allowed to enter target root. go to parent route?
                this.navController.setDirection('root');
                this.router.navigate([this.navigationService.getRootPageUrl()]);
            }
            return false;
        }
    };
    CrmFeatureGuard.ngInjectableDef = i0.defineInjectable({ factory: function CrmFeatureGuard_Factory() { return new CrmFeatureGuard(i0.inject(i1.OrderManager), i0.inject(i2.Router), i0.inject(i2.ActivatedRoute), i0.inject(i3.NavController), i0.inject(i4.NavigationService)); }, token: CrmFeatureGuard, providedIn: "root" });
    return CrmFeatureGuard;
}());
export { CrmFeatureGuard };
